/* Shop the look (PDP) — random cross-type products from a source collection.
   Fetches the collection via /collections/{handle}/products.json (beyond the
   50-product Liquid cap), filters + randomizes client-side, renders brosway
   cards and adds to cart through the theme's `theme:cart:add` event. */
(function () {
  if (window.customElements && customElements.get('shop-the-look')) return;

  function shuffle(a) {
    for (var i = a.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var t = a[i]; a[i] = a[j]; a[j] = t;
    }
    return a;
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  // Shopify-style money formatter. price = major-unit string (e.g. "120.00").
  function formatMoney(priceMajor, format) {
    var cents = Math.round(parseFloat(priceMajor || '0') * 100);
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;

    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands == null ? ',' : thousands;
      decimal = decimal == null ? '.' : decimal;
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      var parts = number.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? decimal + parts[1] : '';
      return whole + frac;
    }

    var match = (format || '${{amount}}').match(placeholder);
    var token = match ? match[1] : 'amount';
    var value;
    switch (token) {
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = withDelimiters(cents, 2, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return (format || '${{amount}}').replace(placeholder, value);
  }

  function imageUrl(p) {
    var src = '';
    if (p.images && p.images.length) src = p.images[0].src || p.images[0];
    else if (p.featured_image) src = p.featured_image;
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=240';
  }

  class ShopTheLook extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      var self = this;
      var io = new IntersectionObserver(function (entries, obs) {
        if (entries[0].isIntersecting) { obs.unobserve(self); self.load(); }
      }, { rootMargin: '0px 0px 400px 0px' });
      io.observe(this);
    }

    async load() {
      var overrideRaw = this.getAttribute('data-override-products');
      if (overrideRaw) {
        try {
          var overrideList = JSON.parse(overrideRaw);
          if (overrideList && overrideList.length) { this.render(overrideList); return; }
        } catch (e) {
          console.error('[shop-the-look] override parse', e);
        }
      }

      var handle = this.getAttribute('data-collection');
      if (!handle) { this.style.display = 'none'; return; }

      var currentId = parseInt(this.getAttribute('data-current-id'), 10);
      var currentType = (this.getAttribute('data-current-type') || '').toLowerCase();
      var count = parseInt(this.getAttribute('data-count') || '4', 10);

      var products = [];
      try {
        for (var page = 1; page <= 4; page++) {
          var res = await fetch('/collections/' + handle + '/products.json?limit=250&page=' + page);
          if (!res.ok) break;
          var data = await res.json();
          if (!data.products || !data.products.length) break;
          products = products.concat(data.products);
          if (data.products.length < 250) break;
        }
      } catch (e) {
        console.error('[shop-the-look]', e);
        this.style.display = 'none';
        return;
      }

      var pool = products.filter(function (p) {
        if (p.id === currentId) return false;
        var t = (p.product_type || '').toLowerCase();
        if (t === currentType) return false;
        if (t.indexOf('accesso') !== -1) return false;
        return (p.variants || []).some(function (v) { return v.available; });
      });

      shuffle(pool);

      var seen = {};
      var picked = [];
      for (var i = 0; i < pool.length && picked.length < count; i++) {
        var t = (pool[i].product_type || '').toLowerCase();
        if (seen[t]) continue;
        seen[t] = true;
        picked.push(pool[i]);
      }

      this.render(picked);
    }

    render(items) {
      var list = this.querySelector('[data-stl-list]');
      var title = this.querySelector('[data-stl-title]');
      if (!list) return;

      if (!items.length) { this.style.display = 'none'; return; }

      var fmt = this.getAttribute('data-money-format') || '${{amount}}';
      var addLabel = escapeHtml(this.getAttribute('data-add-label') || 'Add');
      var priceLabel = escapeHtml(this.getAttribute('data-price-label') || 'Price');
      var cardBg = (this.getAttribute('data-card-bg') || '').trim();
      var bgStyle = cardBg ? ' style="background-color:' + escapeHtml(cardBg) + '"' : '';

      list.innerHTML = items.map(function (p) {
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0] || {};
        var img = imageUrl(p);
        var sku = v.sku ? escapeHtml(v.sku) : '';
        var price = formatMoney(v.price, fmt);
        var titleEsc = escapeHtml((p.title || '').toUpperCase());
        var altEsc = escapeHtml(p.title || '');
        var url = '/products/' + p.handle;

        return '' +
          '<li role="listitem" class="tw-w-full tw-overflow-hidden">' +
            '<article class="shop-the-look__card tw-w-full tw-relative tw-flex tw-gap-[15px] tw-p-[10px]"' + bgStyle + '>' +
              '<a href="' + url + '" class="tw-w-[114px] tw-h-[114px] lg:tw-w-[150px] lg:tw-h-[150px] tw-flex-shrink-0 tw-overflow-hidden">' +
                (img ? '<img src="' + img + '" loading="lazy" alt="' + altEsc + '" class="tw-w-full tw-h-full tw-object-cover">' : '') +
              '</a>' +
              '<div class="tw-flex-1 tw-flex tw-flex-col tw-gap-[12px]">' +
                '<a href="' + url + '"><p class="product-item__title font-brother font-w-medium tw-text-heading-mini">' + titleEsc + '</p></a>' +
                (sku ? '<p class="font-brother font-w-light tw-text-heading-mini tw-text-gray-mid"><span class="tw-sr-only">SKU: </span>' + sku + '</p>' : '') +
                '<p class="product-item__price font-brother font-w-bold tw-text-heading-mini"><span class="tw-sr-only">' + priceLabel + ': </span>' + price + '</p>' +
                '<form action="/cart/add" method="post" class="shop-the-look__form tw-mt-auto tw-self-end">' +
                  '<input type="hidden" name="id" value="' + (v.id || '') + '">' +
                  '<button type="submit" name="add" class="btn btn--primary btn--solid shop-the-look__add"' + (v.id ? '' : ' disabled') + '>' +
                    '<span>' + addLabel + '</span>' +
                  '</button>' +
                '</form>' +
              '</div>' +
            '</article>' +
          '</li>';
      }).join('');

      if (title) title.classList.remove('tw-hidden');
      this.bindAdds();
    }

    bindAdds() {
      this.querySelectorAll('.shop-the-look__form').forEach(function (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          var btn = form.querySelector('button[type="submit"]');
          if (!btn || btn.hasAttribute('disabled')) return;
          document.dispatchEvent(new CustomEvent('theme:cart:add', { detail: { button: btn } }));
        });
      });
    }
  };

  customElements.define('shop-the-look', ShopTheLook);
})();
